import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useDetectSize from '@hooks/useDetectSize';
import { connect } from 'react-redux';
import { Box, ShadowBox } from '@components/common';
import { TableHeading } from '@components/Typography';
import { CleansSelectors } from '@redux/CleansRedux';
import TableAccessaryLabel from '@components/TableAccessaryLabel';
import TableCell from '@components/TableCell';

import { CLEANS_LIST_TYPE } from '@services/minte';

const CleanButton = styled(TableAccessaryLabel)`
  width: 102px;
  max-width: 102px;
`;

function CleansList(props) {
  const { cleansList, type, onItemClick, ...restProps } = props;
  if (!cleansList) {
    return null;
  }

  const isMobile = useDetectSize();

  const title = `${type}`;
  return (
    <Box display="flex" flexDirection="column" {...restProps}>
      <TableHeading mt={2} mb={3}>
        {title}
      </TableHeading>
      <ShadowBox>
        {cleansList.map(item => {
          const key = `clean_${type}_${item.bookingID}`;
          const { formattedDate, formattedDay, serviceType } = item;
          const { title, icon } = serviceType;
          return (
            <TableCell
              key={key}
              title={
                isMobile ? formattedDate : `${formattedDay}, ${formattedDate}`
              }
              renderAccessories={() => (
                <CleanButton
                  p={1}
                  pr={1}
                  flexDirection="row"
                  justifyContent="space-between"
                  title={title}
                  icon={icon}
                  tooltip={title}
                  size="small"
                />
              )}
              onClick={() => {
                if (onItemClick) {
                  onItemClick(item);
                }
              }}
            />
          );
        })}
      </ShadowBox>
    </Box>
  );
}

CleansList.propTypes = {
  cleansList: PropTypes.array,
  type: PropTypes.oneOf([
    CLEANS_LIST_TYPE.ALL,
    CLEANS_LIST_TYPE.PAST,
    CLEANS_LIST_TYPE.FUTURE
  ]).isRequired,
  onItemClick: PropTypes.func
};

CleansList.defaultProps = {
  type: CLEANS_LIST_TYPE.ALL
};

const mapStatesToProps = (state, ownProps) => ({
  cleansList: CleansSelectors.selectCleansList(state, ownProps.type)
});

export default connect(mapStatesToProps)(CleansList);
